import { IconProps } from '../Icon.types';

export const ExportXlsxIcon = ({ width, height, color }: IconProps) => {
  return (
    <svg viewBox="0 0 16 16" width={width} height={height}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 10.85C1 12.5897 2.4103 14 4.15 14H7.27483C7.68905 14 8.02483 13.6642 8.02483 13.25C8.02483 12.8358 7.68905 12.5 7.27483 12.5H6.48828V7.49219H13.5V7.52779C13.5 7.94201 13.8358 8.27779 14.25 8.27779C14.6642 8.27779 15 7.94201 15 7.52779V5.15C15 3.4103 13.5897 2 11.85 2H4.15C2.4103 2 1 3.4103 1 5.15V10.85ZM13.5 5.99219V5.15C13.5 4.23873 12.7613 3.5 11.85 3.5H6.48828V5.99219H13.5ZM4.98828 3.5H4.15C3.23873 3.5 2.5 4.23873 2.5 5.15V5.99219H4.98828V3.5ZM2.5 7.49219V10.85C2.5 11.7613 3.23873 12.5 4.15 12.5H4.98828V7.49219H2.5ZM12.25 9.02344C12.6642 9.02344 13 9.35922 13 9.77344V12.55L13.7443 11.8704C14.0502 11.5911 14.5246 11.6127 14.8039 11.9185C15.0832 12.2244 15.0616 12.6988 14.7557 12.9781L12.7557 14.8042C12.4693 15.0657 12.0307 15.0657 11.7443 14.8042L9.74429 12.9781C9.43841 12.6988 9.41685 12.2244 9.69614 11.9185C9.97543 11.6127 10.4498 11.5911 10.7557 11.8704L11.5 12.55V9.77344C11.5 9.35922 11.8358 9.02344 12.25 9.02344Z"
        fill={color}
      />
    </svg>
  );
};
